// AdsenseComponent.js
import React, { useEffect, useRef } from "react";

const AdsenseComponent = () => {
    // We don't need the prop 'adsenseRef' anymore since we are using 
    // useEffect, but we'll use a local ref for best practice if needed.
    const containerRef = useRef(null); 
    
    // NOTE: The AdSense code is designed to run once the <ins> tag 
    // is rendered and then trigger the ad loading command.

    useEffect(() => {
        // 1. Check if the global AdSense array is available
        if (window.adsbygoogle) {
            try {
                // 2. Execute the ad-loading command after the component 
                //    (with the <ins> tag) has been mounted to the DOM.
                console.log("Adsense: Pushing ad request.");
                (window.adsbygoogle = window.adsbygoogle || []).push({});
            } catch (error) {
                console.error("AdSense Ad loading failed:", error);
            }
        } else {
            console.log("Adsense script not loaded yet.");
        }
    // The empty dependency array ensures this runs only ONCE after the initial render.
    }, []); 

    // The return statement only contains the HTML structure (the ad slot container)
    return (
        <div ref={containerRef} style={{ padding: '10px 0' }}> 
            <ins 
                className="adsbygoogle" // MUST be className in React, not class
                style={{ display: 'block' }} // MUST be an object in React, not a string
                data-ad-client="ca-pub-7155194300607704"
                data-ad-slot="4474302671"
                data-ad-format="auto"
                data-full-width-responsive="true"
            ></ins>
        </div>
    );
}

export default AdsenseComponent;